import React from 'react';
import { bool, func, object, number} from 'prop-types';
import { Elements, StripeProvider } from 'react-stripe-elements';

import 'apps/billing/styles/components/stripe-credit-card-modal.scss';
import StripeCreditCardForm from './stripe-credit-card/stripe-credit-card-form.js';
import stripe from 'library/helpers/stripe';

class CreditCardModal extends React.Component {
  static propTypes = {
    onClose: func,
    // the stripe object brought in via the StripeProvider, has createToken()
    stripe: object,
    // the edit prop is the toggle for create vs edit logic in the form
    edit: bool,
    // Pairin's unique identifier for a payment source (in this case, credit-card)
    source_id: number,
    // If we're editing, this is the saved billing info object to be edited
    values: object
  }

  static defaultProps = {
    values: {}
  }

  state = {
    stripe: null
  }

  load = async () => {
    await stripe.inject();
    this.setState({
      stripe: window.Stripe(__STRIPE_API_KEY__)
    });
  }

  componentDidMount() {
    this.load();
  }

  render() {
    return (
      <div className="hiring-modal">
        <div className="hiring-modal-header">
          <div className="hiring-modal-header-inner">
            <p>{this.props.edit ? `Edit` : `Confirm`} Card Information</p>
            <a onClick={this.props.onClose} href="javascript:void(0)">×</a>
          </div>
          <svg className="hiring-modal-header-svg" width="100%" height="20px" viewBox="0 0 100 50" preserveAspectRatio="none">
            <path className="hiring-modal-header-svg-first" fill="currentColor" strokeWidth="0" d={`M0,0 100,0 100,50 0,0`}></path>
            <path className="hiring-modal-header-svg-second" fill="currentColor" strokeWidth="0" d={`M0,0 100,0 0,50 0,0`}></path>
          </svg>
        </div>
        <div className="hiring-modal-body billing-credit-card-modal-body">
          <StripeProvider stripe={this.state.stripe}>
            <Elements>
              <StripeCreditCardForm
                edit={this.props.edit}
                handleCancel={this.props.onClose}
                {...this.props}
                source_id={this.props.source_id}
                preloadValues={this.props.values}
              />
            </Elements>
          </StripeProvider>
        </div>
      </div>
    );
  }
}

export default CreditCardModal;
